/*eslint-disable */
export default {
  name: 'appFooter',
  components: {},
  props: [],
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
  computed: {

  },
  mounted () {
    
  },
  methods: {
    
  }
}
